import React from "react";
import { Stage } from "../../../core/util/Types";
export const useStage = () => React.useMemo(() => window.location.href.includes('staging') ? Stage.Staging : Stage.Prod, []);
//# sourceMappingURL=UseStage.js.map